export default function get(_ctx = [], currentLang, projectLang) {
  return function(key, source) {
    if (typeof _ctx === 'undefined') {
      return
    }

    const ctx = source || (_ctx && _ctx.props) || []

    if (ctx && typeof ctx === 'object') {
      if (ctx && ctx[key]) {
        return ctx[key][currentLang] === '' || ctx[key][currentLang] === undefined
          ? ctx[key][projectLang]
          : ctx[key][currentLang]
      }
      return
    }
  }
}
